export interface NotificationResponse {
  userId: string;
  companyId: string;
  deviceToken: string;
}

export type NotificationType = 'NEW_SHIFT' | 'UPDATED_SHIFT' | 'DELETED_SHIFT' | 'START_SHIFT';

const SHIFT_DETAIL_TYPES = new Set<string>([
  'NEW_SHIFT',
  'UPDATED_SHIFT',
  'CLOCK_OUT_SHIFT',
  'START_SHIFT',
]);

export const opensShiftDetail = (type: string | undefined): boolean =>
  !!type && SHIFT_DETAIL_TYPES.has(type);

export interface AppNotification {
  id: string;
  title: string;
  body: string;
  type: NotificationType;
  contractId?: string;
  multipleDayContract?: boolean;
  sentAt: string;
  readAt?: string;
}

export interface NotificationStore {
  notifications: AppNotification[];
  lastUpdated: string;
}

export interface FcmPayload {
  id: string;
  title: string;
  body: string;
  data?: {
    contractId?: string;
    notificationType?: string;
    notificationDate?: string;
    multipleDayContract?: string;
  };
}
